import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {DateRangePicker} from '../common/SelectDateRange';

export default function KeyActivities(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource, copyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/society/api!keyActivity.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '活动名称',
			dataIndex: 'activityName',
			width: 140,
		},
		{
			title: '主办单位',
			dataIndex: 'activityUnit',
			width: 140,
		},
		{
			title: '活动时间',
			dataIndex: 'activityDate',
			width: 110,
			sorter: (a, b) => new Date(a.activityDate) - new Date(b.activityDate),
			sortDirections: ['ascend', 'descend', 'ascend'],
		},
		{
			title: '活动形式',
			responsive: ['lg'],
			dataIndex: 'activityForm',
			width: 110,
		},
		{
			title: '活动规模（人）',
			responsive: ['lg'],
			dataIndex: 'activityScope',
			width: 100,
		},
		{
			title: '活动地址',
			dataIndex: 'activityAddress',
			width: 140,
		},
		{
			title: '成果形式',
			responsive: ['lg'],
			dataIndex: 'activityOutcome',
			width: 100,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addKeyActivity.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/activity/key-activity/add')}
					style={{marginBottom: 10}}>新增</Button>
			<DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}


